import { isAuthenticated } from 'modules/common/permissions';

import { DIFFERENT_ORGANIZATION_PATH_NAME } from './data/constants';
import DifferentOrganizationPage from './entry';

export default [
  {
    exact: true,
    path: DIFFERENT_ORGANIZATION_PATH_NAME,
    component: DifferentOrganizationPage,
    permissions: [isAuthenticated],
  },
];
